import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        surveyGroup: '='
    },
    template: `
        <div class="quiz-results">
            <alert-success ng-if="vm.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY === vm.surveyGroup.type">
                {{ 'Survey.Survey submitted successfully. Thank you for the answers.' | translate }}.
            </alert-success>
            <alert-success ng-if="vm.SURVEY_GROUP_TYPE_ENUM.KEYS.INDEPENDENT_SURVEY === vm.surveyGroup.type">
                {{ 'Survey.Answers submitted successfully. Thank you for the answers.' | translate }}.
            </alert-success>
            <div ng-if="vm.redirect">
                </br>
                </br>
                <div class="mt20">{{ vm.getMessage() }}.</div>
                <a class="btn discrete small" ng-click="vm.redirectToPortal()">
                    {{ 'survey.Back to course' | translate }}.
                </a>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $window, $interval, SURVEY_GROUP_TYPE_ENUM) {
        this.$translate = $translate;
        this.$window = $window;
        this.$interval = $interval;
        this.SURVEY_GROUP_TYPE_ENUM = SURVEY_GROUP_TYPE_ENUM;
        this.redirectedIn = 4;
    }

    $onInit () {
        this.redirect = this.surveyGroup.type === this.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY;

        //  Tagasi kursuse juurde

        if (this.redirect) {
            this.$interval(() => {
                if (this.redirectedIn === 0) {
                    this.redirectToPortal();
                }
                else {
                    this.redirectedIn--;
                }
            }, 1000);
        }
    }

    getMessage () {
        return this.$translate.instant('survey.You will be automatically redirected back to course in { seconds } seconds', {
            seconds: this.redirectedIn
        });
    }

    redirectToPortal () {
        this.$window.location.href = this.surveyGroup.portalCourseUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/finished/index.js